import{i as r,l as t}from"./chunk-CI7JPMPN.js";import{m as n}from"./chunk-HBP5N4FR.js";n();t();function c(o){return r[o]}export{c as a};
//# sourceMappingURL=chunk-EBIB2OWL.js.map
